import React, { useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import AppContext from '../../AppContext';
import {
  getProductsAvailableClusters,
  // productsForSearchPageGenreAndClusters,
} from '../../selectors';
import { ClusterLayout } from './ClusterLayout';
import { navigateToCluster } from './navigateToCluster';
import { getGenreParam } from '../../utils/getSearchParam';

const removeClustersThatHaveNoResults = (
  clusters,
) => {
  const returns = [];
  clusters.forEach((c) => {
    returns.push(c);
    // disabled - because slow
    // let clusterWithGenre = `${clusterType}|${c}`;
    // if (genre) {
    //   clusterWithGenre = `${genre || ''}|${clusterType}|${c}`;
    // }
    // const { data } = productsForSearchPageGenreAndClusters(context)(
    //   '',
    //   1,
    //   null,
    //   clusterWithGenre,
    // );
    // if (data && data.length) {
    //   returns.push(c);
    // }
  });
  return returns;
};

export const Clusters = withRouter(
  ({
    history, onSelectCluster, location, title, clusterType, ...props
  }) => {
    const context = useContext(AppContext);
    const availableClusters = getProductsAvailableClusters(context);
    // The menu passes the hovered genre, otherwise use the one in the url
    const genre = props.genre || getGenreParam(location);

    const filteredClusters = availableClusters.filter(
      (ac) => ac.includes(clusterType) && ac.includes(genre),
    );

    const mappedClusters = filteredClusters.map((f) => {
      const nameFor = _.nth(_.reverse(f.split('|')), 1);
      return nameFor;
    });

    const filtersByResults = removeClustersThatHaveNoResults(
      mappedClusters,
      genre,
      context,
      clusterType,
    );

    return (
      <ClusterLayout
        clusters={filtersByResults}
        title={title}
        onClick={navigateToCluster({
          history,
          clusterType,
          onSelectCluster,
          genre,
        })}
      />
    );
  },
);
